<template>
    <div>
        <div class="g-ytsubscribe"
             data-channelid="UCKCkxxpQ7-Wdn_OOyxgfvwA"
             data-layout="full"
             data-count="default"></div>
    </div>
</template>

<script setup>
import {onMounted} from "vue";

// Call the Youtube API Javascript to re render the subscribe button.
onMounted(() => {
    if (window.gapi) {
        window.gapi.ytsubscribe.go(".g-ytsubscribe");
    }
});
</script>

<style scoped>

</style>
